__turbopack_context__.v({
  "dark": "TertiaryButton-module-scss-module__0MgfXG__dark",
  "icon": "TertiaryButton-module-scss-module__0MgfXG__icon",
  "iconTrack": "TertiaryButton-module-scss-module__0MgfXG__iconTrack",
  "iconWrapper": "TertiaryButton-module-scss-module__0MgfXG__iconWrapper",
  "label": "TertiaryButton-module-scss-module__0MgfXG__label",
  "light": "TertiaryButton-module-scss-module__0MgfXG__light",
  "stack-module-0": "TertiaryButton-module-scss-module__0MgfXG__stack-module-0",
  "stack-module-1": "TertiaryButton-module-scss-module__0MgfXG__stack-module-1",
  "stack-module-10": "TertiaryButton-module-scss-module__0MgfXG__stack-module-10",
  "stack-module-11": "TertiaryButton-module-scss-module__0MgfXG__stack-module-11",
  "stack-module-12": "TertiaryButton-module-scss-module__0MgfXG__stack-module-12",
  "stack-module-13": "TertiaryButton-module-scss-module__0MgfXG__stack-module-13",
  "stack-module-14": "TertiaryButton-module-scss-module__0MgfXG__stack-module-14",
  "stack-module-15": "TertiaryButton-module-scss-module__0MgfXG__stack-module-15",
  "stack-module-16": "TertiaryButton-module-scss-module__0MgfXG__stack-module-16",
  "stack-module-17": "TertiaryButton-module-scss-module__0MgfXG__stack-module-17",
  "stack-module-18": "TertiaryButton-module-scss-module__0MgfXG__stack-module-18",
  "stack-module-19": "TertiaryButton-module-scss-module__0MgfXG__stack-module-19",
  "stack-module-2": "TertiaryButton-module-scss-module__0MgfXG__stack-module-2",
  "stack-module-20": "TertiaryButton-module-scss-module__0MgfXG__stack-module-20",
  "stack-module-3": "TertiaryButton-module-scss-module__0MgfXG__stack-module-3",
  "stack-module-4": "TertiaryButton-module-scss-module__0MgfXG__stack-module-4",
  "stack-module-5": "TertiaryButton-module-scss-module__0MgfXG__stack-module-5",
  "stack-module-6": "TertiaryButton-module-scss-module__0MgfXG__stack-module-6",
  "stack-module-7": "TertiaryButton-module-scss-module__0MgfXG__stack-module-7",
  "stack-module-8": "TertiaryButton-module-scss-module__0MgfXG__stack-module-8",
  "stack-module-9": "TertiaryButton-module-scss-module__0MgfXG__stack-module-9",
  "tertiaryButton": "TertiaryButton-module-scss-module__0MgfXG__tertiaryButton",
  "z-base": "TertiaryButton-module-scss-module__0MgfXG__z-base",
  "z-content": "TertiaryButton-module-scss-module__0MgfXG__z-content",
  "z-footer": "TertiaryButton-module-scss-module__0MgfXG__z-footer",
  "z-header": "TertiaryButton-module-scss-module__0MgfXG__z-header",
  "z-hero": "TertiaryButton-module-scss-module__0MgfXG__z-hero",
  "z-logo": "TertiaryButton-module-scss-module__0MgfXG__z-logo",
  "z-logo-effect": "TertiaryButton-module-scss-module__0MgfXG__z-logo-effect",
  "z-navigation": "TertiaryButton-module-scss-module__0MgfXG__z-navigation",
  "z-sub": "TertiaryButton-module-scss-module__0MgfXG__z-sub",
});
